<template>
  <div>

    <div v-if="adminUser" class="mx-3 mt-4">
      <v-autocomplete return-object label="Account" :items="account_list" v-model="account_sel"></v-autocomplete>
    </div>

    <v-list>
      <v-list-tile v-for="item in filteredItems" :key="item.text" :to="item.url">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ item.text }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

  </div>
</template>

<script>
export default {
  name: 'navigation',
  data: () => ({
    items: [
      { icon: 'dashboard', text: 'Dashboard', url: '/' },
      { icon: 'group', text: 'Accounts', url: '/accounts' },
      { icon: 'settings_phone', text: 'Extensions', url: '/extensions' },
      { icon: 'speaker_notes', text: 'Call Records', url: '/callrecords' },
      { icon: 'bar_chart', text: 'Reports', url: '/reports'}
      // { icon: 'attach_money', text: 'Billing Reports', url: '/billreports'}
    ]
  }),
  computed: {
    adminUser: function () {
      return (this.$store.getters.auth_user === 'admin')
    },
    account_list: function () {
      return this.$store.state.admin_acclist
    },
    account_sel: {
      get: function () {
        return this.$store.state.admin_selacc
      },
      set: function (newsel) {
        this.$store.commit('set_admin_selacc', newsel)
      }
    },
    filteredItems: function () {
      let ret = []
      for (var i = 0; i < this.items.length; i++) {
        let add_item = true
        if (!(this.adminUser)) {
          if (this.items[i].text == 'Accounts') {
            add_item = false
          }
        }
        if (add_item) {
          ret.push(this.items[i])
        }
      }
      return ret
    }
  },
  beforeMount: function () {
    if (this.$store.state.admin_acclist.length)
      this.account_sel = this.$store.state.admin_acclist[0]
  }
}
</script>

<style scoped>
</style>
